var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.477,
    height: 17.045,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 2.638h-4.525V1.42A1.412 1.412 0 009.923 0H6.554a1.412 1.412 0 00-1.42 1.42v1.218H.609a.609.609 0 000 1.217h1.2l.852 11.688a1.635 1.635 0 001.623 1.5h7.891a1.62 1.62 0 001.623-1.5l.873-11.688h1.2a.609.609 0 000-1.217zM6.351 1.42a.218.218 0 01.2-.2h3.368a.218.218 0 01.2.2v1.218H6.351V1.42zm6.234 14.042a.415.415 0 01-.406.365H4.285a.415.415 0 01-.406-.365L3.023 3.855h10.41z",
    fill: "#5300f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinPurple);
export default __webpack_public_path__ + "static/media/bin-purple.241a97147e3e4099cb137e97212e7144.svg";
export { ForwardRef as ReactComponent };